module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/izvestaji/izvestaj-za-sokoj/izvestaj-za-sokoj.component.scss
// module id = ./src/app/pages/izvestaji/izvestaj-za-sokoj/izvestaj-za-sokoj.component.scss
// module chunks = main